"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactRedux = require("react-redux");

var _baseModule = _interopRequireDefault(require("./styles/base.module.css"));

var _CallBack = _interopRequireDefault(require("./CallBack"));

var _EnquiryFor = _interopRequireDefault(require("./EnquiryFor"));

var _MembersDetail = _interopRequireDefault(require("./MembersDetail"));

var _OTPVerification = _interopRequireDefault(require("./OTPVerification"));

var _Icons = require("../util/Icons");

var _actions = require("../actions");

var _RegisterEnquiry = _interopRequireDefault(require("./RegisterEnquiry"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

var Enquiry =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Enquiry, _React$Component);

  function Enquiry() {
    _classCallCheck(this, Enquiry);

    return _possibleConstructorReturn(this, _getPrototypeOf(Enquiry).apply(this, arguments));
  }

  _createClass(Enquiry, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
          userID = _this$props.userID,
          getUser = _this$props.getUser;
      getUser(userID);
      var _this$props2 = this.props,
          activity = _this$props2.activity,
          location = _this$props2.location,
          setQueryType = _this$props2.setQueryType;

      if (activity.id) {
        setQueryType({
          queryType: "askQues",
          id: activity.id,
          name: activity.name
        });
      } else {
        setQueryType({
          queryType: "locationBased",
          id: location.id,
          name: location.name
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          callBack = _this$props3.callBack,
          step = _this$props3.step,
          prevStep = _this$props3.prevStep;

      if (callBack) {
        return _react.default.createElement(_CallBack.default, null);
      }

      var component = null;

      switch (step) {
        case 0:
          component = _react.default.createElement(_EnquiryFor.default, null);
          break;

        case 1:
          component = _react.default.createElement(_MembersDetail.default, null);
          break;

        case 2:
          component = _react.default.createElement(_OTPVerification.default, null);
          break;

        case 3:
          component = _react.default.createElement(_RegisterEnquiry.default, null);
          break;

        default:
          component = _react.default.createElement(_EnquiryFor.default, null);
          break;
      }

      return _react.default.createElement("div", {
        className: _baseModule.default.container
      }, step > 0 && step < 3 && _react.default.createElement("button", {
        type: "button",
        className: _baseModule.default.backButton,
        onClick: prevStep
      }, _react.default.createElement(_Icons.BackArrow, {
        width: "0.875rem"
      }), _react.default.createElement("span", null, "Back")), component);
    }
  }]);

  return Enquiry;
}(_react.default.Component);

Enquiry.defaultProps = {
  callBack: false,
  activity: {},
  location: {}
};
Enquiry.propTypes = {
  callBack: _propTypes.default.bool,
  activity: _propTypes.default.object,
  location: _propTypes.default.object,
  userID: _propTypes.default.number.isRequired
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    step: state.step
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    nextStep: function nextStep() {
      return dispatch((0, _actions.nextStep)());
    },
    prevStep: function prevStep() {
      return dispatch((0, _actions.prevStep)());
    },
    getUser: function getUser(id) {
      return dispatch((0, _actions.getUserDetails)(id));
    },
    setQueryType: function setQueryType(enquiry) {
      return dispatch((0, _actions.setQueryType)(enquiry));
    }
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Enquiry);

exports.default = _default;